// extracted by mini-css-extract-plugin
export var chevron = "_ja-3";
export var chevronRotated = "_ja-4";
export var image = "_ja-1";
export var imageContainer = "_ja-0";
export var shippingAddress = "_ja-2";